import http, {makeSearchParams} from 'utils/http';

export const getEnquiries = (data) => {
  return http('GET', 'enquiry', makeSearchParams(data));
};

export const getEnquiry = (id) => {
  return http('GET', `enquiry/${id}`);
};

export const sendEnquiry = (id, type = 'cb', data) => {
  return http('POST', `enquiry/${type}/${id}`, data);
};

export const updateEnquiry = (id, data) => {
  return http('PUT', `enquiry/${id}`, data);
};

export const deleteEnquiry = (id) => {
  return http('DELETE', `enquiry/${id}`);
};

export const getEnquiryReplies = (id, data) => {
  return http('GET', `enquiry/${id}/replies?order=ASC`, makeSearchParams(data));
};

export const createEnquiryReply = (id, data) => {
  return http('POST', `enquiry/${id}/replies`, data);
};

export const postCustomerRequest = (data) => {
  return http('POST', 'customer/request', data);
};

export const getCustomerRequest = (id) => {
  if (id) {
    return http('GET', `customer/request/${id}`);
  }

  return http('GET', `customer/request`);
};
